import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";
import { RouteMap } from "components/common/navigation/routeMap";
import { Link, matchPath, withRouter } from "react-router-dom";
import { getUrlWithQuery } from "cxa-utils";
import { useSelector } from "react-redux";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";
import hasMenuWithId from "../HasMenuWithId";

export const getCurrentTopNav = (pathname, menus) => {
  if (
    pathname == "/shop/enrolment" ||
    pathname == "/shop/checkout" ||
    pathname == "/shop/checkout/success"
  ) {
    return menus.find(x => x.children && x.children.find(c => c.id === "FlexBenefitsMain"));
  }
  return menus.find(
    x =>
      (x.children &&
        x.children.filter(c => c.id === Object.keys(RouteMap).find(k => RouteMap[k] === pathname))
          .length > 0) ||
      matchPath(pathname, { path: RouteMap[x.id] })
  );
};

const getSecondaryRoutes = (pathname, currentTopNav) => {
  return currentTopNav.children.reduce((acc, x) => {
    if (x.id === "FlexBenefitsMain_PendingClaims") {
      // eslint-disable-next-line no-secrets/no-secrets
      x.id = "FlexBenefitsMain_TrackClaims";
    }
    if (RouteMap[x.id]) {
      let isPathActive = matchPath(pathname, { path: RouteMap[x.id] });
      if (
        !isPathActive &&
        ((RouteMap[x.id] == "/claims/submit" &&
          matchPath(pathname, { path: RouteMap["ClaimPreview"] })) ||
          (x.id == "FlexBenefitsMain" &&
            (matchPath(pathname, { path: RouteMap["FlexBenefitsMain_CheckOut"] }) ||
              matchPath(pathname, { path: RouteMap["FlexBenefitsMain_CheckOutSuccess"] }))))
      ) {
        isPathActive = true;
      }
      acc.push({
        url: RouteMap[x.id],
        label: x.name,
        active: isPathActive,
        externalUrl: x.externalUrl,
      });
    }
    return acc;
  }, []);
};

const SecondaryNavPP = ({ location, items, selectedLanguage, intl, isNarrowScreen }) => {
  const menuItems = useSelector(state => state.common.menuItems);

  const helpSettings = useSelector(state => state.needhelp.response);
  if (!items || items.length === 0) {
    return null;
  }
  const { pathname } = location;

  const currentTopNav = getCurrentTopNav(pathname, items);
  const hasSecondaryRoutes =
    currentTopNav && currentTopNav.children && currentTopNav.children.length > 0;
  if (!hasSecondaryRoutes) {
    return null;
  }

  const { code: langCode = "" } = selectedLanguage;
  const secondaryRoutes = getSecondaryRoutes(pathname, currentTopNav).map(sRoute => {
    const { externalUrl } = sRoute;

    if (externalUrl) {
      return {
        ...sRoute,
        externalUrl: getUrlWithQuery(externalUrl, { langid: langCode.replace("-", "") }),
      };
    }

    return sRoute;
  });

  // hardcode documents link to the secondary nav until we have a configuration for it.
  currentTopNav.id == "FlexBenefitsMain_MyClaims" &&
    secondaryRoutes.push({
      active: matchPath(pathname, { path: RouteMap["ClaimDocuments"] }),
      externalUrl: undefined,
      label: intl.formatMessage({ id: "Documents", defaultMessage: "Documents" }),
      url: "/claims/documents",
    });

  // show menu ecards and clinics under benefits menu if the menu available for claims page
  const hasClinicsMenu = hasMenuWithId(
    menuItems,
    "FlexBenefitsMain_MyClaims",
    "FlexBenefitsMain_Clinics"
  );

  const hasEcardsMenu = hasMenuWithId(
    menuItems,
    "FlexBenefitsMain_MyClaims",
    "FlexBenefitsMain_eCard"
  );

  if (currentTopNav.id == "FlexBenefitsMain_MyBenefits") {
    if (hasEcardsMenu) {
      secondaryRoutes.push({
        active: matchPath(pathname, { path: RouteMap["BenefitsECards"] }),
        externalUrl: undefined,
        label: intl.formatMessage({ id: "eCards", defaultMessage: "eCards" }),
        url: "/benefits/eCards",
      });
    }
    
    if (hasClinicsMenu) {
      secondaryRoutes.push({
        active: matchPath(pathname, { path: RouteMap["BenefitsClinics"] }),
        externalUrl: undefined,
        label: intl.formatMessage({ id: "Clinics", defaultMessage: "Clinics" }),
        url: "/benefits/clinics",
      });
    }
  }
  
  let videos = [];
  if (currentTopNav.id == "FlexBenefitsMain_MyClaims") {
    videos = (helpSettings.items || []).filter(item => item.title === "Claims");
  } else if (currentTopNav.id == "FlexBenefitsMain_MyBenefits") {
    videos = (helpSettings.items || []).filter(item => item.title === "Enrolment");
  }
  return (
    <nav className="nav-side-menu accordion">
      <div className="panel">
        <ul style={{ listStyle: "none", padding: "0" }}>
          {secondaryRoutes.map(item => (
            <li
              style={
                isNarrowScreen
                  ? { lineHeight: "4rem" }
                  : { lineHeight: "4rem", fontSize: "1.125em" }
              }
              key={item.url}
            >
              {item.active && (
                //CHANGE color
                <Link
                  to={item.externalUrl || item.url}
                  className={`csp-side-menu__item ${isNarrowScreen ? "product-plan--active" : ""}`}
                >
                  <strong>
                    <FormattedMessage id={item.label} defaultMessage={item.label} />
                  </strong>
                </Link>
              )}
              {!item.active && (
                <Link
                  to={item.externalUrl || item.url}
                  className="csp-side-menu__item"
                  style={isNarrowScreen ? { color: "white" } : { color: "black" }}
                >
                  <FormattedMessage id={item.label} defaultMessage={item.label} />
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      {videos.length > 0 && videos[0].title && videos[0].url && !isNarrowScreen && (
        <div>
          <div className="panel">
            <div style={{ border: "2px solid lightgrey" }}></div>
            <div>
              <h4>
                <strong> {intl.formatMessage(messages.watchTutorialText)}</strong>
              </h4>
              <figure className="cxa-c-media">
                <video controls>
                  <source src={videos[0].url} title={videos[0].title} />
                  <track kind="captions" />
                </video>
              </figure>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

SecondaryNavPP.propTypes = {
  location: PropTypes.object,
  items: PropTypes.array,
  selectedLanguage: PropTypes.object,
  intl: intlShape.isRequired,
};

SecondaryNavPP.defaultProps = {
  selectedLanguage: {},
};

export default injectIntl(
  withRouter(withMatchMediaProps({ isNarrowScreen: { maxWidth: 600 } })(SecondaryNavPP))
);



// WEBPACK FOOTER //
// ./components/common/navigation/SecondaryNavPP.js